export default "__VITE_ASSET__5ee87190__"